const upperCase = text =>{
    const turkishUpperCaseMap = {
        'i': 'İ',
        'ı': 'I',
        'ş': 'Ş',
        'ç': 'Ç',
        'ğ': 'Ğ',
        'ö': 'Ö',
        'ü': 'Ü'
        };
    return text.replace(/[iışçğöü]/g, match => turkishUpperCaseMap[match]).toUpperCase();
}

export default upperCase